import React from 'react';
import { DatePickerEditor } from './DatePickerEditor';
import { IEditorProps } from '../Editor';

interface IDateTimePickerEditorProps extends IEditorProps {}

/**
 * Editor for picking both date and time.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function DateTimePickerEditor(props: IDateTimePickerEditorProps) {
  // currently switching on IsDate EditorConfigurationValue
  return <DatePickerEditor {...props} isDateTimePicker={true} />;
}
